// @ts-nocheck
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_PICKUP_MEMO,
  DELETE_PICKUP_MEMO,
  Edit_Pickup_Memo,
  GET_LOAD_RECEIPT,
  GET_MEMO_BY_ID,
  GrtPreferenceByFormKey,
  Lock_Pickup_Memo,
  getDefaultVoucherSeries,
  getFormSectionsAndFields,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import MemoMainComponent from "../../LRTable/MemoMainComponent";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import LRPickupUpdationFreightChargesForm from "../LRPickupUpdation/LRPickupUpdationSections/LRPickupUpdationFreightChargesForm";
import "./AddPickupMemo.scss";
import { FreightCharges, PickupMemoConfiguration, PickupVoucherConfig, Pickupmemodocs } from "./AddPickupMemoConfig";

import { IoSettingsOutline } from "react-icons/io5";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import {
  ClearFields,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import InvoiceNumberConfiguration from "../InvoiceNumberConfiguration/InvoiceNumberConfiguration";
import { useRecoilState } from "recoil";
import { AtomFormState } from "../../../../atoms/FormAtom";
import useFetchTableData from "../../../custom_hooks/useFetchTableData";
import useProcessData from "../../../../CommonFunction/ProcessData";
import { RiErrorWarningFill } from "react-icons/ri";
import { Confirm } from "../../Confirmation/Confirm";
axios.defaults.withCredentials = true;


const queryfunction = (fields: []) => {
  const query = gql`
  query getLoadReceiptData_WithPopulate($Type: String, $warehouseId: ID) {
    getLoadReceiptData_WithPopulate(Type: $Type, warehouseId: $warehouseId) {
        _id
     ${fields?.join(" ")}
        }
        }    
        `;
  return query;
};


const AddPickupMemo = ({
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  openByCard = false,
  FormDetailsByCard,
  openByCardId
}) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, " Pickup Assignment (PRS Generation)");
  const { pushModal, popModal } = useModalContext();
  const Form_Key = "Pickup_Memo";
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Pickup_Memo?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentBranch, setCurrentBranch] = useState("");
  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  const [triggerLRList, setTriggerLRList] = useState(false)
  const [sendValue, setSendValue] = useState(0);
  const [FormValue, setFormValue] = useRecoilState(AtomFormState(Form_Key));
  const [totalWeight, setTotalWeight] = useState<number>();
  const [totalFreightAmount, setTotalFreightAmount] = useState<number>();
  const [notedata, setNotesdata] = useState(fielddata ? fielddata.Narration : "");
  const [LRData, setLRData] = useState([]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [OpenBookCodeSet, setOpenBookCodeSet] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const [LRData1, setLRData1] = useState<any[]>([]);
  const [allFieldsData, setAllFieldsData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [LRTableListData, setLRTableListData] = useState([])
  const [LRList, setLRList] = useState<any[]>([]);
  const [InputFields, setInputFields] = useState([]);
  const [freightFields, setFreightFields] = useState([]);
  const [DocumentsFields, setDocumentsFields] = useState([]);
  const [createdMemo, setCreatedMemo] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);

  // Q & M
  const [EditPickup, { loading: EditLoading }] = useMutation(Edit_Pickup_Memo, {
    onCompleted: () => {
      Closeformfunction();
    },
  });
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        let PickupFieldData = data?.formSectionAndFields.filter((e) => e.name === "Pickup_Memo_Details");
        let FreightFieldData = data?.formSectionAndFields.filter((e) => e.name === "Freight_Charges");
        let DocumentsField = data?.formSectionAndFields.filter((e) => e.name === "Documents");
        setInputFields(PickupFieldData);
        setFreightFields(FreightFieldData);
        setDocumentsFields(DocumentsField)
      },
    }
  );
  const [getDefaultBillNo] = useLazyQuery(getDefaultVoucherSeries, {
    fetchPolicy: "network-only",
  });
  const [CreatePickupMemo, { loading: AddLoading, error, data }] = useMutation(CREATE_PICKUP_MEMO);
  const [LockPickupMemo, { loading: LockLoading }] = useMutation(Lock_Pickup_Memo);
  const [DeletePickupMemo, { loading: deleteLoading }] = useMutation(DELETE_PICKUP_MEMO);
  const [formdata, setformdata] = useState(data ? data.GetLoadsOnRequestedData : []);

  const [fetchAccountGroup, { loading: queryLoading, error: TableError, data: TableData }] = useLazyQuery(queryfunction([]), {
    variables: {
      Type: "Pickup Memo",
    },
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchAccountGroup, setIsLoading, `${Form_Key}_forLRTable`, triggerLRList);


  // const { data: LRdata, refetch: LRRefetch } = useQuery(GET_LOAD_RECEIPT, {
  //   variables: {
  //     Type: "Pickup Memo",
  //   },
  //   fetchPolicy: "network-only",
  // });

  const [GetMemoById, { loading: getLoading, data: memoData }] = useLazyQuery(GET_MEMO_BY_ID, {
    fetchPolicy: "network-only",
  });
  const [getDataByKey] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });
  const LoadingState = AddLoading || getLoading || EditLoading ? true : false;

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Pickup_Memo?.SelRows_ids);
  }, [fielddataRedux]);


  useEffect(() => {
    if (FormData?.Mode && !allFieldsData?.Vehicle) {
      setFormValue({ Mode: FormData?.Mode });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Vehicle: {},
          },
        },
      });
      updateSingleField(formRef, "Vehicle", "");
    }
  }, [FormData?.Mode]);


  useEffect(() => {
    if (FormDataFromRedux?.MasterData?.[Form_Key]?.Driver_Name && !allFieldsData?.Driver_Name) {
      let obj = FormDataFromRedux?.MasterData?.[Form_Key]?.Driver_Name;
      updateSingleField(formRef, "Driver_Number", obj?.Mobile_Number);
    }
  }, [FormData?.Driver_Name]);

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id) {
      ClearSpecificForm(dispatch, Form_Key);
      ClearFields(formRef);
      setTriggerLRList((prev) => !triggerLRList)
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Branch_Code: value,
          },
        },
      });
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  const SetBillNumber = () => {
    let BookCode = FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series;
    let NextNumber = FormData?.Bill_No || "";

    let ConCat = `${BookCode?.Prefix ? BookCode?.Prefix : ""}${NextNumber}${BookCode?.Sufix ? BookCode?.Sufix : ""}`;
    updateSingleField(formRef, "PRS_NO", ConCat);
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (LRData.length === 0) {
      return WarningToast("Please Select at Least 1 Lr");
    } else if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (TableData && TypeOfPortal === "Add") {
      // console.log(LRdata, "LRdataLRdataLRdataLRdata")
      let lr = ConvertDateValues(TableData?.getLoadReceiptData_WithPopulate) || [];

      setLRList((prev) => [...lr]);
    }
  }, [TableData]);

  useEffect(() => {
    if (TableData && (TypeOfPortal === "Edit" || TypeOfPortal === "View")) {
      let lr = ConvertDateValues(TableData.getLoadReceiptData_WithPopulate) || [];

      let lr2 = ConvertDateValues(allFieldsData?.LoadReceiptsData) || [];

      setLRList((prev) => [...lr, ...lr2]);
    }
  }, [TableData, allFieldsData]);

  const getNetBillNumber = (bookCode = "") => {
    // console.log(bookCode);
    getDefaultBillNo({
      variables: {
        FormKey: Form_Key,
        bookCode,
      },
    }).then(({ data }) => {
      let defaultNo = data?.getAutoVoucheSeries;
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: { Voucher_Series: defaultNo },
        },
      });
      updateSingleField(
        formRef,
        "PRS_NO",
        `${defaultNo.Prefix ? defaultNo.Prefix : ""}${defaultNo.Bill_No ? defaultNo.Bill_No : ""}${defaultNo.Sufix ? defaultNo.Sufix : ""
        }` || ""
      );

      setFormdata((prev) => ({
        ...prev,
        Voucher_Series: `${defaultNo.Prefix ? defaultNo.Prefix : ""}${defaultNo.Bill_No ? "***" : ""}${defaultNo.Sufix ? defaultNo.Sufix : ""
          }`,
        Bill_No: defaultNo.Bill_No,
      }));
    });
  };

  const getDefaultValues = async () => {
    getNetBillNumber();
    const { data } = await getDataByKey({
      variables: {
        Form_Key,
      },
    });
    let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };
    // console.log(obj, "configurationData");
    dispatch({
      type: "StoreMasterData",
      payload: {
        formkey: "Preference",
        data: {
          Default_Voucher_Series: obj.Default_Voucher_Series,
        },
      },
    });
    obj.Default_Voucher_Series = obj.Default_Voucher_Series?.Search_Value;

    setFormdata((prev) => ({
      ...prev,
      ...obj,
    }));

    return data?.User_Preferences_By_Form_Key?.configurationData;
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete" && !isFirstLoad) {
        // console.log(fielddata, "fielddatafielddatafielddata")
        GetMemoById({
          variables: {
            id: openByCard ? openByCardId : fielddata?._id,
          },
        }).then((res) => {
          let MemoData = res?.data?.getAllPickupMemosByID_WithPopulate[0];
          let MemoObj = { ...MemoData };
          // console.log(MemoObj, "MemoDataMemoData");
          setLRData1(ConvertDateValues(MemoData?.LoadReceiptsData));
          // if (MemoObj?.customFieldData && typeof MemoObj.customFieldData === "object") {
          //   Object.entries(MemoObj.customFieldData).forEach(([key, value]) => {
          //     MemoObj[key] = value ?? "";
          //   });
          // }
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Driver_Name: MemoObj?.Driver_Name_Data,
                Vehicle: MemoObj?.Vehicle_Data,
                Vendor_ID: MemoObj?.Vendor_Data,
                Drop_At: MemoObj?.Drop_At_Data,
                Branch_Code: MemoObj?.Branch_Code_Data,
                Voucher_Series: MemoObj?.Voucher_Series_Data,
              },
            },
          });

          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: "Preference",
              data: {
                Default_Voucher_Series: MemoObj?.Default_Voucher_Series,
              },
            },
          });

          // console.log(MemoObj, "MemoDataMemoData2");
          MemoObj.Vendor_ID = MemoObj?.Vendor_Data?.Search_Value;
          MemoObj.Vehicle = MemoObj?.Vehicle_Data?.Vehicle_No;
          MemoObj.Driver_Name = MemoObj?.Driver_Name_Data?.Name;
          MemoObj.Date = IsoToDateWithoutTime(MemoObj.Date);
          MemoObj.Drop_At = MemoObj?.Drop_At_Data?.Warehouse_Name;

          setTotalFreightAmount(MemoObj?.Freight_Amount);
          setNotesdata(MemoObj?.Notes);
          setFormdata((prev) => ({
            ...prev,
            Voucher_Series: MemoObj?.Voucher_Series_Data?.Search_Value,
            Default_Voucher_Series: MemoObj?.Default_Voucher_Series?.Search_Value,
            Bill_No: MemoObj?.Bill_No,
          }));
          updateValueForm(formRef, MemoObj);
          setAllFieldsData(MemoObj);
        });
      } else {
        getDefaultValues();
        if (openByCard) {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Branch_Code: FormDetailsByCard?.LR_Data[0]?.Assign_Pickup_Data,
              },
            },
          });
          // console.log(FormDetailsByCard?.LR_Data[0]?.Assign_Pickup_Data?.Name, "FormDetailsByCard");
          updateSingleField(formRef, "Branch_Code", FormDetailsByCard?.LR_Data[0]?.Assign_Pickup_Data?.Name);
          let lrobj = FormDetailsByCard?.LR_Data;
          setLRData1(ConvertDateValues(lrobj));
        }
        updateValueForm(formRef, { Date: GetTodaysDateINdmy(), Mode: "Truck" });
        setFirstLoad(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata, InputFields]);

  useEffect(() => {
    // Get the DOM elements
    const settings = document.getElementsByClassName("InputEditIcon");

    // Function to be called on click
    const handleClickSettings = () => {
      setOpenBookCodeSet(true);
    };

    // Attach the click event listener to each element
    Array.from(settings).forEach((element) => {
      element.addEventListener("click", handleClickSettings);
    });

    // Clean up the event listeners when the component unmounts
    return () => {
      Array.from(settings).forEach((element) => {
        element.removeEventListener("click", handleClickSettings);
      });
    };
  }, [InputFields]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);



  useEffect(() => {
    if (totalWeight) {
      updateSingleField(formRef, "Total_Weight", totalWeight);
    }
  }, [totalWeight]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    const fields = extractCustomFields(InputFields);
    setStoreCustomFields(fields);
  }, [InputFields]);

  let newFormData = FormData;

  const getId = (value) => value?._id ?? null;




  //function to perform CRUD Opetation
  const submit = async (close) => {
    const idArray = LRData.map((item: any) => item._id);

    let data = processFormDataWithCustomFields(newFormData, storeCustomFields);
    data.Notes = notedata;
    data.LoadReceiptsIds = idArray;
    data.Date = data.Date ? convertToISO(data?.Date) : null;
    data.Vehicle = getId(FormDataFromRedux.MasterData[Form_Key]?.Vehicle);
    data.Default_Voucher_Series = getId(FormDataFromRedux?.MasterData?.Preference?.Default_Voucher_Series);
    data.Vendor_ID = getId(FormDataFromRedux?.MasterData?.[Form_Key]?.Vendor_ID);
    data.Driver_Name = getId(FormDataFromRedux?.MasterData?.[Form_Key]?.Driver_Name);
    data.Voucher_Series = getId(FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series);
    data.Drop_At = getId(FormDataFromRedux?.MasterData?.[Form_Key]?.Drop_At);
    data.Driver_Number = data?.Driver_Number ? String(data?.Driver_Number) : "";
    if (TypeOfPortal.includes("Edit")) {
      await EditPickup({
        variables: { editPickupMemoId: openByCard ? openByCardId : fielddata?._id, input: data },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Pickup Assignment(PRS) Edited Successfully");
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await CreatePickupMemo({
        variables: {
          PickupMemoInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Pickup Assignment(PRS) Created Successfully")
          ClearSpecificForm(dispatch, Form_Key);
          handleFormReset(formRef);
          setNotesdata("");
          setCreatedMemo(true);
          setTimeout(() => {
            setCreatedMemo(false);
          }, 100);
          if (close === "close") {
            Closeformfunction();
          }
          updateValueForm(formRef, { Date: GetTodaysDateINdmy(), Mode: "Truck" });
          setLRList(prev => [])
          setTriggerLRList((prev) => !triggerLRList)
          getDefaultValues();
        })
        .catch((err) => {
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  let handleDeleteUpdation = async () => {
    await DeletePickupMemo({
      variables: {
        idsToDelete: selectedRows,
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast("Pickup Assignment Deleted Successfully");
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  let handleLockRecords = async () => {
    await LockPickupMemo({
      variables: {
        idsToUpdate: selectedRows,
        Is_Lock: TypeOfPortal == "Lock" ? true : false
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast(`Pickup Assignment ${TypeOfPortal} Successfully`);
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  // eslint-disable-next-line
  const Closeformfunction = () => {
    ClearSpecificForm(dispatch, Form_Key);
    handleFormReset(formRef);
    setNotesdata("");
    settoggle(false);
    ParentPortalCloseFunction();
  };



  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={handleDeleteUpdation}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(false);
          }}
          loadingState={deleteLoading}
        />
      </Reactportal>
    );
  }

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={handleLockRecords}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={LockLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={handleDeleteUpdation}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(false);
          }}
          loadingState={deleteLoading}
        />
      </Reactportal>
    );
  }

  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={modifiedTypeOfPortal}
        // id={allFieldsData && allFieldsData._id ? allFieldsData._id : id}
        // TypeOfId={allFieldsData?.Voucher_No ? allFieldsData?.Voucher_No : ""}
        ShowBranchInput={true}
        Form_Key={Form_Key}
        idTitle="Voucher No"
        AdditionalContent={() => {
          return (
            <span onClick={HandleSettingClick} className="settingIcon">
              {" "}
              <IoSettingsOutline className="settingIcon" />
            </span>
          );
        }}
      >
        {LoadingState && <div className="loader-line-div" />}
        <div className="Pickupmemomaindiv">
          <div className="horizontalcontainer">
            {InputFields &&
              InputFields.map((e) => {
                return (
                  <div key={e.id} className="">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="horizantalSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onhandleFormikChange={HanldeChangeonForm}
                        validation_Schema={e?.Valid_schema}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        formkey={Form_Key}
                        formRef={formRef}
                        TypeOfPortal={TypeOfPortal}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          <div>
            {/* {LRList?.length && ( */}
            <MemoMainComponent
              data={LRList}
              TypeofPortal={`CN List For ${TypeOfPortal} Pickup Memo`}
              fielddata={""}
              totalWeight={(val: number) => setTotalWeight(val)}
              setLR={(val) => setLRData(val)}
              SelectedData={LRData1}
              createdMemo={createdMemo}
              formkey={Form_Key}
              openByCard={openByCard}
              TableHeaders={TableHeaders}
            />
            {/* )} */}
          </div>
          <div className="NoteImageHeading">
            <div className="subNoteImage">
              <div>
                <p className="NoteLable1">Notes: </p>
              </div>
              <div className="moredetailsection1">
                <textarea name="note" value={notedata} onChange={(e) => setNotesdata(e.target.value)}></textarea>
              </div>
            </div>
            <div className="subNoteImage">
              <div className="">
                {DocumentsFields?.length > 0 &&
                  DocumentsFields.map((e) => {
                    return (
                      <div key={e.id} className="">
                        <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                        <div className="horizantalSection insidecontainer">
                          <FormInputSectionComponent
                            inputfields={e.fields}
                            Type={e.name}
                            onhandleFormikChange={HanldeChangeonForm}
                            validation_Schema={e?.Valid_schema}
                            onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                            formkey={Form_Key}
                            TypeOfPortal={TypeOfPortal}
                            formRef={formRef}
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
            <div className="subNoteImage">
              <div>
                <p className="NoteLable3">Charges: </p>
              </div>
              <div className="Freight">
                {freightFields &&
                  freightFields.map((e: any, i) => {
                    return (
                      <LRPickupUpdationFreightChargesForm
                        inputfields={e.fields}
                        Type={e.name}
                        totalFreightAmount={totalFreightAmount}
                        handleFreightOnChange={() => { }}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        FormData={FormData}
                        formRef={formRef}
                        onhandleFormikChange={HanldeChangeonForm}
                        handleErrorsChange={() => handleErrorsChange()}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          {OpenBookCodeSet && (
            <InvoiceNumberConfiguration
              show={OpenBookCodeSet}
              voucherNumberConfig={PickupVoucherConfig}
              setOpenBookCodeSet={setOpenBookCodeSet}
              formRef={formRef}
              FormData={FormData}
              setFormData={setFormdata}
              Form_Key={Form_Key}
              SetBillNumber={SetBillNumber}
            />
          )}
          {openSetting && (
            <FormConfiguration
              show={openSetting}
              ParentClosingFunction={setOpenSetting}
              config={PickupMemoConfiguration}
              HanldeChangeonForm={HanldeChangeonForm}
              formRef={formRef}
              setFirstLoad={setFirstLoad}
              allFieldsData={allFieldsData}
              getFormSectionAndFields={getFormSectionAndFields}
              formKey={Form_Key}
              forFormValues={FormData}
              preference={true}
              ToGetDefaultValues={() => {
                getDefaultValues();
              }}
            />
          )}
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitType={submitType}
          loadingState={LoadingState}
          Form_key={Form_Key}
          TypeOfPortal={TypeOfPortal}
          submitform={() => {
            Validate_handleSubmit(submit);
          }}
          SaveAndClose={() => {
            Validate_handleSubmit(() => {
              submit("close");
            });
          }}
          handleformclose={() => {
            // settoggle(!toggle);
            Closeformfunction();
          }}
        />
      </Reactportal>
    </>
  );
};

export default AddPickupMemo;
